'use client'

import { LinkCaseStudiesDetail } from '@/components/links/case'
import { LinkProps } from '@/components/links/links.types'
import { CaseStudies } from '@/entities/caseStudies'
import { useGlobalValue } from '@/lib/store/useGlobal'
import IconArrowRight from '@icon/variable/arrow-right.svg'
import { cn } from '@utils'
import Image from 'next/image'

export default function CaseStudiesCard({
  data,
  className,
  ...props
}: LinkProps & { data: CaseStudies }) {
  const { mobile } = useGlobalValue()

  return (
    <LinkCaseStudiesDetail
      slug={data.slug}
      scroll={mobile}
      native={mobile}
      className={cn('relative group/case cursor-pointer block overflow-hidden', className)}
      {...props}
    >
      <div className='w-full h-full overflow-hidden rounded-tl-4xl rounded-br-4xl aspect-[442/526]'>
        {data.coverSrc && (
          <Image
            src={data.coverSrc}
            alt={data.subject}
            width={442}
            height={526}
            className='w-full h-full object-cover pointer-events-none transition-transform duration-500 group-hover/case:scale-110'
          />
        )}
      </div>
      <div className='absolute inset-0 p-5 flex flex-col transition-[background] duration-5000 bg-linear-to-b from-black/0 to-black/0 group-hover/case:to-black/60 rounded-tl-4xl rounded-br-4xl'>
        <div className='flex-1 grid place-items-center'>
          <button
            type='button'
            className='grid place-items-center w-15 h-15 bg-primary rounded-lg transition-opacity opacity-0 group-hover/case:opacity-100 duration-500 delay-100 cursor-pointer'
          >
            <IconArrowRight className='fill-white w-4 h-4 -rotate-45' />
          </button>
        </div>
        <div className='bg-white/70 rounded-xl py-4 px-5 backdrop-blur-md transition-all duration-500 opacity-0 group-hover/case:opacity-100 translate-y-full group-hover/case:translate-y-0'>
          <h3 className='text-2xl font-bold line-clamp-2'>{data.subject}</h3>
          <p className='text-secondary/70 line-clamp-2 mt-2'>{data.brief}</p>
        </div>
      </div>
    </LinkCaseStudiesDetail>
  )
}
